module.exports = __webpack_public_path__ + "files/d0438a4060c3098269cfa36c5a405cd6.png";